<style src="css/leave.css" scoped></style>
<template>
  <div style="padding-top: 1rem;padding-bottom: .98rem">
    <topbar text="请假"></topbar>
    <div class="mainBox" v-if="type ===1">
      <div class="titleBox">
        请假原因：
      </div>
      <textarea v-model="remark" placeholder="请输入原因"></textarea>
      <div class="titleBox">
        请假时间：
      </div>
      <div class="timeBox" v-if="doctorDetail.chatDoctorSchedules">
        <div class="item" v-for="item in doctorDetail.chatDoctorSchedules">
          <div class="timeItem"
               :class="{active:JSON.parse(item.dateValue).length>0,active2:item.scheduleId===scheduleId}">
            <div
              :class="{timeItemStatus:JSON.parse(item.dateValue).length>0,timeItemStatusActive:item.scheduleId===scheduleId}"></div>
            {{ item.scheduleDate | week }}
            <span>{{ item.scheduleDate | MM }}</span>
          </div>
          <div class="itemBlock" :class="{active:item.scheduleId===scheduleId&&time===v}"
               v-for="v in JSON.parse(item.dateValue)" @click="selectDateTime(item.scheduleDate,v,item.scheduleId)">
            {{ v }}
          </div>
        </div>

      </div>
    </div>
    <div class="bottomBox active" @click="doDoctorLeaveSure()">
      提交
    </div>
    <div class="maskBox" v-if="maskStatus">
      <div class="mask">
        <div class="maskTop">
          <div class="maskTitle" style="margin-bottom: 0" v-html="startContent"></div>
        </div>
        <div class="btnBox">
          <div class="btn" @click="cancle">取消</div>
          <div class="btn active" @click="sureStart()">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getSource, getSources} from "../api"

import noMoreData from 'components/no-more-data'
import topbar from 'components/topbar'
import moment from 'moment/moment'

import {Swiper, Slide} from 'vue-swiper-component';
import {serialize} from 'utils/index'

export default {
  data() {
    return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      maskStatus: false,
      startContent: '提交成功后，系统将自动取消排班和待咨询的单次预约单，你确定要提交吗?',
      doctorId: '',
      doctorDetail: {},
      serveType: '',
      name: '',
      scheduleId: '',
      type: 1,
      weekScheduleList: [],

      leaveDate: '',
      remark: '',
      time: ''
    }
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
      return transTime
    },

    MM(value) {
      let transTime = moment(value).format('MM-DD')
      return transTime
    },
    isWeek(v) {
      let arr = ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日']
      return arr[v]
    },
    week(value) {
      let time = moment(value).format('dddd');
      let obj = {
        'Monday': '周一',
        'Tuesday': '周二',
        'Wednesday': '周三',
        'Thursday': '周四',
        'Friday': '周五',
        'Saturday': '周六',
        'Sunday': '周日'
      }
      return obj[time]
    }
  },
  computed: {},
  methods: {
    cancle() {
      // this.connType='';
      // this.startContent='';
      this.maskStatus = false
    },
    back() {
      history.back()
    },
    changeType(n) {
      this.type = n;
      if (n === 1) {
        this.getDoctorScheduleToBespeak()
      } else {
        this.getDoctorWeekSchedule()
      }
    },
    selectDateTime(d, t, id) {
      console.log(moment(d).format('YYYY-MM-DD'))
      console.log(t)
      this.time = t;
      this.scheduleId = id;
      this.leaveDate = `${moment(d).format('YYYY-MM-DD')} ${t}:00`
      console.log(this.leaveDate)
    },
    init() {
      this.leaveDate = '';
      this.scheduleId = '';
      this.time = '';
    },
    getDate(value) {
      let transTime = moment(value).format('YYYY-MM-DD') + ' '
      return transTime
    },
    select(a, b, c) {
      if (a) {
        this.serveType = b;
        this.name = c;
      }
    },
    async getDoctorScheduleToBespeak() {
      let obj = {}
      obj.doctorId = this.doctorId;
      obj.type = 1;
      let data = await getSources("/bear-scale/api/chatDoctor/getDoctorScheduleToBespeak.json", obj);
      if (data.status === 0) {
        this.doctorDetail = data.doctorSchedule
      } else {
        alert(data.msg)
      }
    },
    async getDoctorWeekSchedule() {
      let obj = {}
      obj.doctorId = this.doctorId;
      let data = await getSources("/bear-scale/api/chatDoctor/getDoctorWeekSchedule.json", obj);
      if (data.status === 0) {
        this.weekScheduleList = data.weekScheduleList
      } else {
        alert(data.msg)
      }
    },
    sureStart() {
      this.doDoctorLeave();
    },
    doDoctorLeaveSure() {
      if (!this.remark) {
        alert(`请输入请假原因`)
      } else if (!this.leaveDate) {
        alert(`请选择请假时间`)
      } else {
        this.maskStatus = true
      }
    },
    async doDoctorLeave() {
      if (!this.remark) {
        alert(`请输入请假原因`)
      } else if (!this.leaveDate) {
        alert(`请选择请假时间`)
      } else {
        let obj = {}
        obj.doctorId = this.doctorId;
        obj.leaveDate = this.leaveDate;
        obj.remark = this.remark;
        let data = await getSources("/bear-scale/api/chatDoctor/doDoctorLeave.json", obj);
        if (data.status === 0) {
          alert(`提交成功`)
          this.init()
          this.getDoctorScheduleToBespeak()
          this.maskStatus = false
        } else {
          alert(data.msg)
        }
      }

    },
    to(n) {
      this.$router.push(`/${n}`)
    },
  },
  destroyed() {

  },
  mounted() {
    this.doctorId = localStorage.getItem('doctorId')
    if (this.$route.query.type) {
      this.changeType(parseInt(this.$route.query.type))
    } else {
      this.getDoctorScheduleToBespeak()
    }


  }
}
</script>



// WEBPACK FOOTER //
// src/components/leave.vue